import { z } from 'zod';

/**
 * Política de contraseña (fix-60, alcance extra del dev). Espejo de
 * `apps/api/src/common/validation/contrasena.ts` (`ContrasenaSegura`): el back es quien decide; aquí
 * solo se guía al usuario en tiempo real. Los mismos casos se prueban en los dos lados.
 */
export const CONTRASENA_MIN = 8;
export const CONTRASENA_MAX = 128;

export interface ReglaContrasena {
  id: 'longitud' | 'letra' | 'numero' | 'especial';
  texto: string;
  cumple: (valor: string) => boolean;
}

export const REGLAS_CONTRASENA: readonly ReglaContrasena[] = [
  { id: 'longitud', texto: `Mínimo ${CONTRASENA_MIN} caracteres`, cumple: (v) => v.length >= CONTRASENA_MIN },
  { id: 'letra', texto: 'Al menos una letra', cumple: (v) => /\p{L}/u.test(v) },
  { id: 'numero', texto: 'Al menos un número', cumple: (v) => /\d/.test(v) },
  { id: 'especial', texto: 'Al menos un carácter especial (por ejemplo ! # - .)', cumple: (v) => /[^\p{L}\d\s]/u.test(v) },
];

export function cumpleTodas(valor: string): boolean {
  return REGLAS_CONTRASENA.every((regla) => regla.cumple(valor));
}

export const definirContrasenaSchema = z
  .object({
    contrasena: z
      .string()
      .max(CONTRASENA_MAX, `La contraseña no puede superar ${CONTRASENA_MAX} caracteres`)
      .refine(cumpleTodas, 'La contraseña no cumple todas las reglas'),
    confirmacion: z.string().min(1, 'Confirma la contraseña'),
  })
  .refine((v) => v.contrasena === v.confirmacion, {
    message: 'Las contraseñas no coinciden',
    path: ['confirmacion'],
  });

export type DefinirContrasenaValues = z.infer<typeof definirContrasenaSchema>;

export const recuperarSchema = z.object({
  correo: z.string().min(1, 'Ingrese su correo').email('Ingrese un correo válido'),
});

export type RecuperarValues = z.infer<typeof recuperarSchema>;
